import { z } from 'zod'
import type { ParserLink } from './parser'

/**
 * Lightweight runtime check for `ParserLink[]` payloads. Trusts producers
 * (`extractRefs()` / `parseAndBuildChildren()`) and only asserts the minimal
 * fields needed to safely render refs downstream.
 *
 * Lives in its own file (sibling of `parser.ts`) so consumers don't pull in
 * peggy / typesense / `search.server.ts` (`server-only`) at runtime.
 *
 * If `ParserLink` gains required fields that consumers depend on, mirror
 * them here.
 */
export const refsSchema = z.custom<ParserLink[]>(
  (val) =>
    Array.isArray(val) &&
    val.every(
      (r) =>
        r !== null && typeof r === 'object' && 'id' in r && 'citation' in r,
    ),
  { message: 'Invalid refs' },
)
